module.exports = __webpack_public_path__ + "img/SKMJ_ladder5.71fa7ed1.jpg";